//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { LOGO_SIZE } from "@/constants/ui.js";

export default {
  name: "LogoSizeChoice",

  props: {
    size: {
      type: [String, Number],
    },
    options: {
      type: Array,
    }
  },
  computed: {
    getLogoSize() {
      return this.options ?? LOGO_SIZE
    },
  }
}
